export const SET_RESERVATION_TYPES = 'SET_RESERVATION_TYPES'
export const SET_MATCHER_ITEM = 'SET_MATCHER_ITEM'
export const SET_MATCHER_FOR_DISPLAY = 'SET_MATCHER_FOR_DISPLAY'
export const CLEAR_SELECT_MATCH_FIELD = 'CLEAR_SELECT_MATCH_FIELD'
export const SET_ISSUES_AN_IS_VALID = 'SET_ISSUES_AN_IS_VALID'
export const SET_DATE_TIME_FORMAT = 'SET_DATE_TIME_FORMAT'
export const SET_SELECTED_TZ = 'SET_SELECTED_TZ'
export const CLEAR_MATCH_DATA = 'CLEAR_MATCH_DATA'
